/* paginagewicht 2026-11-04: script van de productpagina (sectienavigatie, foto's, lightbox). Geladen met defer. */
;(() => {
    const nav = document.querySelector('.pinfo-nav');
    if (!nav) return;
    const links = [...nav.querySelectorAll('a[data-spy]')];
    const map = new Map(links.map((a) => [a.dataset.spy, a]));
    const sections = links.map((a) => document.getElementById(a.dataset.spy)).filter(Boolean);
    if (!('IntersectionObserver' in window) || !sections.length) return;
    const list = nav.querySelector('.pinfo-nav__list');
    /* 2026-10-28 schuif-pdp: in de veegbare rij (telefoon) schuift het actieve onderdeel mee in beeld */
    const setActive = (id) => links.forEach((a) => {
      const on = a.dataset.spy === id;
      a.classList.toggle('is-active', on);
      if (!on || !list || !list.scrollBy || list.scrollWidth <= list.clientWidth + 1) return;
      const lr = list.getBoundingClientRect(), ar = a.getBoundingClientRect();
      if (ar.left < lr.left || ar.right > lr.right) list.scrollBy({ left: ar.left - lr.left - 14, behavior: 'smooth' });
    });
    const io = new IntersectionObserver((entries) => {
      const visible = entries.filter((e) => e.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio);
      if (visible[0]) setActive(visible[0].target.id);
    }, { rootMargin: '-130px 0px -55% 0px', threshold: [0.01, 0.2] });
    sections.forEach((s) => io.observe(s));
  })();

  (() => {
    document.querySelectorAll('form[action*="/cart/add"] select[name="id"]').forEach((select) => {
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        window.rabeVariantGa(url.toString());
      });
    });
  })();

  (() => {
    document.querySelectorAll('[data-pcar]').forEach((wrap) => {
      const track = wrap.querySelector('[data-pcar-track]');
      const prev = wrap.querySelector('[data-pcar-prev]');
      const next = wrap.querySelector('[data-pcar-next]');
      if (!track || !next) return;
      const step = (dir) => track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
      next.addEventListener('click', () => step(1));
      if (prev) prev.addEventListener('click', () => step(-1));
      const sync = () => {
        if (prev) prev.hidden = track.scrollLeft < 10;
        next.hidden = track.scrollLeft > track.scrollWidth - track.clientWidth - 10;
      };
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  })();

  (() => {
    document.querySelectorAll('[data-gallery]').forEach((gal) => {
      const slides = [...gal.querySelectorAll('.pgallery__slide')].filter((s) => s.dataset.slide);
      const thumbs = [...gal.querySelectorAll('.pgallery__thumb')];
      if (slides.length < 2) return;
      const show = (id) => {
        slides.forEach((s) => s.classList.toggle('is-active', s.dataset.slide === id));
        thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.target === id));
      };
      thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(thumb.dataset.target)));
      const step = (dir) => {
        const cur = slides.findIndex((s) => s.classList.contains('is-active'));
        const next = (cur + dir + slides.length) % slides.length;
        show(slides[next].dataset.slide);
      };
      const prevBtn = gal.querySelector('[data-gal-prev]');
      const nextBtn = gal.querySelector('[data-gal-next]');
      if (prevBtn) prevBtn.addEventListener('click', () => step(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => step(1));
    });
  })();

  /* Foto-lightbox (2026-07-29): klik op de hoofdfoto opent 'm schermvullend.
     Zoomen met scroll/dubbelklik/knoppen/pinch, slepen om te schuiven,
     pijltjes of swipe om te wisselen, Esc of klik naast de foto om te sluiten. */
  (() => {
    const gal = document.querySelector('[data-gallery]');
    const box = document.querySelector('[data-lightbox]');
    if (!gal || !box) return;
    if (box.parentNode !== document.body) document.body.appendChild(box);

    const stage = box.querySelector('[data-lb-stage]');
    const img = box.querySelector('[data-lb-img]');
    const level = box.querySelector('[data-lb-level]');
    const count = box.querySelector('[data-lb-count]');
    const prevBtn = box.querySelector('[data-lb-prev]');
    const nextBtn = box.querySelector('[data-lb-next]');
    const MIN = 1;
    /* Bovengrens hangt af van de bronresolutie: een scherpe datasheet mag ver
       inzoomen, een kleine leveranciersfoto stopt eerder i.p.v. te vervagen. */
    let maxScale = 4;
    let items = [];
    let idx = 0;
    let scale = 1;
    let tx = 0;
    let ty = 0;
    let opener = null;

    const isOpen = () => !box.hidden;
    const clamp = (v, min, max) => Math.min(max, Math.max(min, v));

    const apply = () => {
      const bx = Math.max(0, (img.offsetWidth * scale - stage.clientWidth) / 2);
      const by = Math.max(0, (img.offsetHeight * scale - stage.clientHeight) / 2);
      tx = clamp(tx, -bx, bx);
      ty = clamp(ty, -by, by);
      img.style.transform = 'translate(' + tx + 'px, ' + ty + 'px) scale(' + scale + ')';
      box.classList.toggle('is-zoomed', scale > 1.005);
      if (level) level.textContent = Math.round(scale * 100) + '%';
    };

    /* Zoomt naar (ox, oy): een punt t.o.v. het midden van het speelveld, zodat
       de plek onder de muis op z'n plaats blijft. */
    const zoomTo = (next, ox, oy) => {
      const from = scale;
      scale = clamp(next, MIN, maxScale);
      const f = scale / from;
      if (scale <= MIN) {
        tx = 0;
        ty = 0;
      } else {
        tx = ox - (ox - tx) * f;
        ty = oy - (oy - ty) * f;
      }
      apply();
    };

    const pointOf = (e) => {
      const r = stage.getBoundingClientRect();
      return { x: e.clientX - r.left - r.width / 2, y: e.clientY - r.top - r.height / 2 };
    };

    const show = (i) => {
      if (!items.length) return;
      idx = (i % items.length + items.length) % items.length;
      scale = 1;
      tx = 0;
      ty = 0;
      box.classList.add('is-loading');
      img.src = items[idx].src;
      img.alt = items[idx].alt;
      apply();
      const multi = items.length > 1;
      if (prevBtn) prevBtn.hidden = !multi;
      if (nextBtn) nextBtn.hidden = !multi;
      if (count) {
        count.hidden = !multi;
        count.textContent = (idx + 1) + ' / ' + items.length;
      }
    };
    img.addEventListener('load', () => {
      box.classList.remove('is-loading');
      /* Tot circa 3x boven de eigen pixels: verder is het toch alleen wazig. */
      const shown = img.offsetWidth || 1;
      maxScale = clamp((img.naturalWidth / shown) * 3, 2.5, 6);
      apply();
    });

    const open = (id) => {
      items = [...gal.querySelectorAll('.pgallery__slide[data-zoom]')].map((s) => ({
        id: s.dataset.slide,
        src: s.dataset.zoom,
        alt: (s.querySelector('img') || {}).alt || ''
      }));
      if (!items.length) return;
      const found = items.findIndex((it) => it.id === id);
      opener = document.activeElement;
      box.hidden = false;
      box.removeAttribute('aria-hidden');
      document.documentElement.classList.add('rb-lb-open');
      show(found < 0 ? 0 : found);
      const closeBtn = box.querySelector('.rb-lightbox__close');
      if (closeBtn) closeBtn.focus();
    };

    const close = () => {
      if (!isOpen()) return;
      box.hidden = true;
      box.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('rb-lb-open');
      img.removeAttribute('src');
      if (opener && opener.focus) opener.focus();
      opener = null;
    };

    gal.addEventListener('click', (e) => {
      if (e.target.closest('.pgallery__nav')) return;
      if (e.target.closest('[data-lb-open]')) {
        const active = gal.querySelector('.pgallery__slide.is-active[data-zoom]');
        open(active ? active.dataset.slide : null);
        return;
      }
      const slide = e.target.closest('.pgallery__slide[data-zoom]');
      if (slide && slide.classList.contains('is-active')) open(slide.dataset.slide);
    });

    box.querySelectorAll('[data-lb-close]').forEach((b) => b.addEventListener('click', close));
    if (prevBtn) prevBtn.addEventListener('click', () => show(idx - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => show(idx + 1));
    const zoomIn = box.querySelector('[data-lb-zoomin]');
    const zoomOut = box.querySelector('[data-lb-zoomout]');
    if (zoomIn) zoomIn.addEventListener('click', () => zoomTo(scale * 1.5, 0, 0));
    if (zoomOut) zoomOut.addEventListener('click', () => zoomTo(scale / 1.5, 0, 0));

    stage.addEventListener('wheel', (e) => {
      e.preventDefault();
      const p = pointOf(e);
      zoomTo(scale * (e.deltaY < 0 ? 1.2 : 1 / 1.2), p.x, p.y);
    }, { passive: false });

    stage.addEventListener('dblclick', (e) => {
      const p = pointOf(e);
      zoomTo(scale > 1.005 ? 1 : 2.5, p.x, p.y);
    });

    /* Slepen (1 vinger/muis) en knijpen (2 vingers). */
    const pts = new Map();
    let pinch = null;
    let moved = false;
    let startX = 0;
    let downOn = null;
    stage.addEventListener('pointerdown', (e) => {
      if (e.button && e.button !== 0) return;
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pts.size === 1) {
        moved = false;
        startX = e.clientX;
        /* Vastleggen VOORDAT setPointerCapture het doel verlegt naar het speelveld. */
        downOn = e.target;
      } else if (pts.size === 2) {
        const p = [...pts.values()];
        pinch = { d: Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y), s: scale };
      }
      if (stage.setPointerCapture) stage.setPointerCapture(e.pointerId);
    });
    stage.addEventListener('pointermove', (e) => {
      const p = pts.get(e.pointerId);
      if (!p) return;
      const dx = e.clientX - p.x;
      const dy = e.clientY - p.y;
      p.x = e.clientX;
      p.y = e.clientY;
      if (pts.size >= 2 && pinch && pinch.d > 0) {
        const v = [...pts.values()];
        zoomTo(pinch.s * (Math.hypot(v[0].x - v[1].x, v[0].y - v[1].y) / pinch.d), 0, 0);
        moved = true;
        return;
      }
      if (scale > 1.005) {
        tx += dx;
        ty += dy;
        moved = true;
        apply();
      }
    });
    const release = (e) => {
      if (!pts.has(e.pointerId)) return;
      pts.delete(e.pointerId);
      if (pts.size < 2) pinch = null;
      if (pts.size > 0) return;
      if (e.type !== 'pointerup') return;
      const dx = e.clientX - startX;
      if (scale <= 1.005 && items.length > 1 && Math.abs(dx) > 60) {
        show(idx + (dx < 0 ? 1 : -1));
        return;
      }
      /* Klik naast de foto sluit; klik op de foto zelf niet (dubbelklik = zoomen). */
      if (!moved && downOn === stage) close();
    };
    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', release);

    window.addEventListener('resize', () => { if (isOpen()) apply(); });

    document.addEventListener('keydown', (e) => {
      if (!isOpen()) return;
      const k = e.key;
      if (k === 'Escape') close();
      else if (k === 'ArrowRight') show(idx + 1);
      else if (k === 'ArrowLeft') show(idx - 1);
      else if (k === '+' || k === '=') zoomTo(scale * 1.5, 0, 0);
      else if (k === '-' || k === '_') zoomTo(scale / 1.5, 0, 0);
      else if (k === '0') zoomTo(1, 0, 0);
      else return;
      e.preventDefault();
    });
  })();
